import { useContext } from 'react'
import { RoleRestrictionsContext } from '@/context/RoleRestrictionsContext/RoleRestrictionsContext'

export const useRoleRestrictions = () => {
  const context = useContext(RoleRestrictionsContext)
  if (!context) {
    throw new Error(
      'useRoleRestrictions must be used within RoleRestrictionsProvider'
    )
  }
  return context
}
